module.exports = __webpack_public_path__ + "static/media/logo_criatec_branco.daa8b75e.png";